import PropTypes from 'prop-types';
import { Common, color } from '@stockbit/ui';

import { ButtonTradingGreen } from './styled';

const { Text, Iconmoon, IconWrapper } = Common;

const ButtonTradingFill = ({ isActive, minimize, label, ...otherProps }) => (
  <ButtonTradingGreen
    isActive={isActive}
    minimize={minimize}
    {...otherProps}
    data-cy="top-navbar-button-start-trading"
  >
    <Text
      align={minimize ? 'left' : 'center'}
      color={isActive ? color.trading : color.light}
      family="bold"
      size="15px"
    >
      {label}
    </Text>
    {isActive && (
      <IconWrapper size="16px" style={{ marginTop: '-10px' }}>
        <Iconmoon
          className="icon-toolbar_down"
          color={isActive ? color.trading : color.light}
        />
      </IconWrapper>
    )}
  </ButtonTradingGreen>
);

ButtonTradingFill.propTypes = {
  isActive: PropTypes.bool,
  minimize: PropTypes.bool,
  label: PropTypes.string,
};

ButtonTradingFill.defaultProps = {
  isActive: false,
  minimize: false,
  label: 'START TRADING',
};

export default ButtonTradingFill;
